<template>
  <div
    class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-blueGray-100 border-0"
  >
    <BannerNotification />
    <ImageSliderUpdatePageHeader
      :handleUpdate="handleUpdateSlider"
      :handleCopy="handleCopySlider"
      :instanceId="instanceId"
      :componentId="componentId"
      :title="instanceName"
      :componentName="componentName"
    />
    <ImageSliderUpdatePageForm
      :formData="formData"
      :instanceId="instanceId"
      @update:formData="handleUpdateFormData"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import BannerNotification from "@/components/Shared/Notification/BannerNotification";
import ImageSliderUpdatePageHeader from "@/components/ComponentModule/ImageSliderComponent/ImageSliderUpdatePageHeader";
import ImageSliderUpdatePageForm from "@/components/ComponentModule/ImageSliderComponent/ImageSliderUpdatePageForm";

export default {
  name: "ImageSliderUpdatePage",
  components: {
    BannerNotification,
    ImageSliderUpdatePageHeader,
    ImageSliderUpdatePageForm
  },
  data() {
    return {
      formData: { slider: { slides: [] } }
    };
  },
  props: {
    componentId: {
      type: String,
      required: true
    },
    instanceId: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.$store.dispatch(Actions.FETCH_COMPONENT_DATA, {
      region: this.getRegion,
      componentId: this.$route.params.compId
    });
    this.$store.dispatch(Actions.FETCH_SLIDE_INSTANCE, {
      region: this.getRegion,
      componentId: this.getComponentId("abi_image_slide")
    });
    this.$store.dispatch(Actions.FETCH_SLIDE_ATTRIBUTES, {
      region: this.getRegion,
      componentId: this.getComponentId("abi_image_slide")
    });
  },
  computed: {
    instanceName() {
      if (
        this.getInstanceInfo.find(
          (item) => item.id === this.$route.params.instanceId
        )
      ) {
        return this.getInstanceInfo.find(
          (item) => item.id === this.$route.params.instanceId
        ).instance_name;
      } else {
        return "";
      }
    },
    componentName() {
      if (
        this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        )
      ) {
        return this.getAllComponent.find(
          (item) => item.id === this.$route.params.compId
        ).name;
      } else {
        return "";
      }
    },
    ...mapGetters([
      "getAllComponent",
      "getInstanceInfo",
      "getRegion",
      "currentUser"
    ])
  },
  methods: {
    handleUpdateFormData(val) {
      this.formData = val;
    },
    handleUpdateSlider() {
      this.$store.dispatch(Actions.UPDATE_SLIDER_INSTANCE, {
        region: this.getRegion,
        formData: this.formData,
        instanceId: this.instanceId,
        user: this.currentUser.email,
        currentUrl: window.location.href
      });
    },
    handleCopySlider() {
      this.$store
        .dispatch(Actions.COPY_SLIDER_INSTANCE, {
          region: this.getRegion,
          formData: this.formData,
          componentId: this.componentId,
          title: this.instanceName.split("|")[1],
          user: this.currentUser.email
        })
        .then(() => {
          this.$router.push({ path: `/component/${this.componentId}` });
        });
    },
    getComponentId(name) {
      const foundItem = this.getAllComponent.find((item) => item.name === name);
      if (foundItem) {
        return foundItem.id;
      } else {
        return null;
      }
    }
  }
};
</script>
